import { actionSimple } from '@legacyApp/client/modules/app/actionService';
import { PERFORMANCE_SET_IS_LOW_PERFORMANCE } from './performance.constants';

export const performanceSetIsLowPerformance = actionSimple(
	PERFORMANCE_SET_IS_LOW_PERFORMANCE,
);
